import styled from "styled-components/macro";
import { H3 } from "../../../../components/Typography/Typography";
import { LoadingIcon } from "../../../../components/Icons/Icons";
import { useTranslation } from "react-i18next";

const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.resolve("spacing_xl")};
  width: 100%;
`;

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.resolve("spacing_xl")};
  overflow: hidden;
  border-radius: ${({ theme }) => theme.resolve("radius_md")};
  width: 100%;
`;

const InfoSection = styled.div`
  background-color: ${({ theme }) => theme.resolve("color_bg_surface_brand3")};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.resolve("spacing_xs")};
  width: 100%;
`;

const InfoSectionInner = styled.div`
  border: ${({ theme }) => theme.resolve("border_md")} solid
    ${({ theme }) => theme.resolve("color_border_brand")};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.resolve("spacing_xl")};
  padding: ${({ theme }) => theme.resolve("spacing_xl")};
  border-radius: ${({ theme }) => theme.resolve("radius_md")};
  width: 100%;
  box-sizing: border-box;
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.resolve("spacing_md")};
  align-items: center;
  padding: ${({ theme }) => theme.resolve("spacing_xl")} 0;
  border-radius: ${({ theme }) => theme.resolve("radius_xs")};
  width: 100%;
  box-sizing: border-box;
`;

const LoadingIconWrapper = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
`;

const MessageText = styled.p`
  font-family: ${({ theme }) => theme.resolve("font_family_primary")};
  font-size: 15px;
  font-weight: ${({ theme }) => theme.resolve("font_weight_regular")};
  line-height: 23px;
  color: ${({ theme }) => theme.tokens.semanticColors.textPrimary};
  text-align: center;
  margin: 0;
  letter-spacing: -0.15px;
  min-width: 100%;
  width: 100%;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export function UploadingCSVModalBody(): JSX.Element {
  const { t } = useTranslation();

  return (
    <ModalContentWrapper>
      <TitleContainer>
        <H3 style={{ margin: 0 }}>{t("Uploading CSV")}</H3>
      </TitleContainer>
      <SectionContainer>
        <InfoSection>
          <InfoSectionInner>
            <LoadingContainer>
              <LoadingIconWrapper>
                <LoadingIcon width={40} height={40} />
              </LoadingIconWrapper>
              <MessageText>
                {t(
                  "Please wait while we upload and process the CSV. This process may take a few moments, depending on the size of your data. We are ensuring that all information is correctly uploaded and integrated into the system."
                )}
              </MessageText>
            </LoadingContainer>
          </InfoSectionInner>
        </InfoSection>
      </SectionContainer>
    </ModalContentWrapper>
  );
}
